import type { TableSortingProps } from './Table.types';

import { cn } from 'utils/cn';

import ArrowIcon from 'components/Icons/ArrowIcon';

const TableSorting = <TData extends object>({
  column
}: TableSortingProps<TData>) => {
  const isSorted = column.getIsSorted();
  const isSortedAsc = isSorted === 'asc';
  const isSortedDesc = isSorted === 'desc';

  return (
    <button
      onClick={() => {
        if (!isSorted) {
          column.toggleSorting(false);
        } else if (isSortedAsc) {
          column.toggleSorting(true);
        } else {
          return column.clearSorting();
        }
      }}
      className='size-3 py-0.5 px-1'
    >
      <ArrowIcon
        className={cn(
          'rotate-90 fill-gray-600 transition-colors duration-300',
          'hover:fill-blue-200',
          {
            'fill-blue-200': isSorted,
            '-rotate-90': isSortedDesc
          }
        )}
      />
    </button>
  );
};

export default TableSorting;
